import { render, staticRenderFns } from "./search_menu.vue?vue&type=template&id=1b8e802b&"
import script from "./search_menu.vue?vue&type=script&lang=js&"
export * from "./search_menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports